<template>
  <b-row
    class="justify-content-center m-0"
    align-v="center"
    align-h="center"
    :style="{ height: '100%' }"
  >
    <div v-if="!isLoading">
      <b-row class="box-content m-0">
        <!-- column left -->
        <b-col class="box-content__left">
          <div class="content-left">
            <div class="mb-u6 text__title">Please verify your email</div>

            <div class="mb-u6 text_description">
              A link has been sent to
              <span class="text__email text-primary">{{ email ? email : 'EMAIL_NOT_DETECT' }}</span>
              You have to verify your email within 24 hours Otherwise, you have to proceed again.
            </div>
            <div class="d-flex mb-u6">
              <b-button
                class="button__resend-verify-email"
                variant="primary"
                name="send-verify-email-button"
                :disabled="isWaiting"
                disable-event-track
                @click="onClickSendVerifyEmail"
              >
                <b-spinner v-if="isLoading" small label="Loading..." class="mb-u1" />

                <span v-else>Send Verification</span>
              </b-button>
            </div>
            <span>or </span>

            <span class="link__to-new-email text-primary" @click="toChangeEmail()"
              >Change to new email</span
            >

            <div v-if="isWaiting">
              <div class="text__description mt-u4">Email verification has been sent.</div>
              <div class="text__description">
                New email verification can be requested again in
                {{ countDownSecond }} seconds.
              </div>
            </div>
          </div>
        </b-col>
        <!-- column right -->
        <b-col class="box-content__right">
          <b-row class="content-right m-0"
            ><b-img class="img-right" :src="require(`@/assets/email-and-message.png`)"
          /></b-row>
        </b-col>
      </b-row>
    </div>
  </b-row>
</template>

<script>
import { userInfoMixin } from '@/mixins/userInfoMixin';
import ChangeRequest from '@/models/ChangeRequest';

import { amplitudeMixin } from '@/mixins/amplitudeMixin';

const changeRequestStatus = {
  PROCESSED: 'Processed',
  FAILED: 'Failed',
  PENDING: 'Pending'
};

export default {
  mixins: [amplitudeMixin, userInfoMixin],

  data: () => ({
    email: 'EMAIL NOT FOUND',
    requestId: '',
    countDownSecond: 0,
    coolDown: 60,
    isLoading: false,

    isSendEmailFail: false
  }),

  computed: {
    isWaiting() {
      // wait 60 secs after re send email
      return this.countDownSecond !== 0;
    }
  },

  watch: {
    countDownSecond(value) {
      if (value > 0) {
        setTimeout(() => {
          this.countDownSecond--;
        }, 1000);
      }
    }
  },

  async created() {
    await this.init();
  },

  methods: {
    onClickSendVerifyEmail(event) {
      this.$_amplitudeMixin_onClick(event.currentTarget);
      this.sendVerifyEmail();
    },

    async init() {
      this.isLoading = true;
      await this.checkRequestStatus();

      this.isLoading = false;
    },

    async sendVerifyEmail(coolDown = this.coolDown) {
      this.clearError();

      this.isLoading = true;

      try {
        await ChangeRequest.api().resendVerifyRequestChange(this.requestId);
      } catch (error) {
        this.isSendEmailFail = true;
      } finally {
        this.isLoading = false;
      }

      this.countDownSecond = coolDown;

      localStorage.setItem('kmutt4life__resent-verify-email-at', Date.now());
    },

    async clearError() {
      this.isSendEmailFail = false;
    },

    toChangeEmail() {
      this.$router.push({ name: 'profile/edit-email' });
    },
    async checkRequestStatus() {
      //get request data
      this.requestId = this.$route.query.requestId;

      if (!this.requestId) {
        return changeRequestStatus.FAILED;
      }

      const {
        response: { data }
      } = await ChangeRequest.api().getChangeRequestById(this.requestId);

      if (data && data.request_data) {
        this.$set(this, 'email', data.request_data.newEmail);
        return data.status;
      } else {
        return changeRequestStatus.FAILED;
      }
    }
  }
};
</script>

<style scoped>
.text__title {
  font-weight: 700;
  font-size: 26.6px;
  line-height: 32px;
  color: #3b3e66;
}

.text__description {
  font-weight: 400;
  font-size: 15.2px;
  line-height: 22px;
  color: #3b3e66;
}
.link__to-new-email {
  text-decoration: underline;
  cursor: pointer;
}

.image__background {
  height: 352px;
  background: #f1f1fd;
  border-radius: 10.4px;
}

.box-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 50px 10px;
  padding: 5%;
}
.content-left {
  padding-left: 20%;
}

.box-content__right .img-right {
  max-width: 400px;
}

.content-right {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

@media only screen and (max-width: 767px) {
  .box-content {
    flex-direction: column-reverse;
    gap: 20px 25px;
  }
  .content-left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-left: 0%;
  }

  .box-content__right .img-right {
    min-width: 250px;
  }
  .content-right {
    justify-content: center;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991.98px) {
  .box-content {
    gap: 50px 0;
  }
  .box-content__right .img-right {
    min-width: 250px;
    width: 100%;
  }
}
</style>
